jQuery(document).ready(function($) {
    //lazy loading
    $(".lazy").Lazy();

    //hero slider
    $(".js-hero-slider")
        .slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            dots: false,
            arrows: true,
            speed: 1200,
            adaptiveHeight: true,
            appendArrows: $(".js-hero-card")
        })
        .on("beforeChange", function(event, slick, currentSlide, nextSlide) {
            var bg = $('.js-hero-slide[data-slick-index="' + nextSlide + '"]').data(
                "bg"
            );
            $(".js-hero-bg").stop().animate({ opacity: 0 }, 200, function() {
                $(this).css("background-image", "url("+ bg +")");
                $(this).animate({ opacity: 1 }, { duration: 800 });
            });
            // $(".js-hero-bg").delay(500).queue(function(){
            //   $(this).css({"background-image":"url("+ bg +")"});
            // });
            // $(".js-hero-bg").css("background-image", "url("+ bg +")");
        });

    //menu scroll
    function scrollToSection(self, e) {
        e.preventDefault();
        $("html, body").animate({
                scrollTop: $($(self).attr("href")).offset().top - 50
            },
            700,
            "swing"
        );
    }
    $(".js-nav").on("click", 'a[href*="#"]', function(e) {
        if($(this).parents('ul').hasClass('sub-menu')){
          var slide = $($(self).attr("href")).data('slick-index');
          $('.js-services-slider').slick('slickGoTo', slide, true);
          $("html, body").animate({
            scrollTop: $($(this).attr("href")).offset().top - 150
        },
        700,
        "swing"
    );
          return;
        }
        scrollToSection(this, e);
    });
    $(".js-mobile-nav").on("click", 'a[href*="#"]', function(e) {
        if($(this).parents('ul').hasClass('sub-menu')){
          var slide = $($(self).attr("href")).data('slick-index');
          $('.js-services-slider').slick('slickGoTo', slide, true);
          $("html, body").animate({
            scrollTop: $($(this).attr("href")).offset().top - 150
        },
        700,
        "swing"
    );
          return $('.js-mobile-nav').removeClass('active');
        }
        $('.js-mobile-nav').removeClass('active');
        scrollToSection(this, e);
    });
    
    $(".js-hero-btn").click(function(e) {
        scrollToSection(this, e);
    });

    //services slider
    $(".js-services-slider")
        .slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            speed: 400,
            adaptiveHeight: true
        })
        .on("beforeChange", function(event, slick, currentSlide, nextSlide) {
            $(".js-current-service").text(nextSlide + 1);
        });

    $(".js-form input").on("focusin", function(e) {
        $(this)
            .parent()
            .find("label")
            .addClass("active");
    });
    $(".js-form input").on("focusout", function(e) {
        if (e.target.value === "") {
            $(this)
                .parent()
                .find("label")
                .removeClass("active");
        }
    });

    //hamburger
    $(".js-hamburger").click(function() {
        $(".js-mobile-nav").toggleClass("active");
    });

    $(".js-mobile-nav-close").click(function() {
        $(".js-mobile-nav").toggleClass("active");
    });

    //form
    $('.js-form').submit(function(e) {
        e.preventDefault();
        $form = $(this);
        $form.find('button[type="submit"]').attr("disabled", true);
        $form.find('button[type="submit"]').append($('<div class="lds-dual-ring"></div>'));
        var data = {
            action: "contactform",
            name: $form.find('input[name="name"]').val(),
            email: $form.find('input[name="email"]').val(),
            company: $form.find('input[name="company"]').val(),
            message: $form.find('input[name="message"]').val(),
            verify: $form.find('input[name="email_verify"]').val()
        }
        var url = $form.attr('action');
        $.post(url, data, function(res) {
            $form.find('button[type="submit"]').remove();
            $form.append($('<div class="form__response">').text(res.message));
        }, 'json');
    });

    // End of document ready
});

//Init Wow
window.onload = function() {
    jQuery(".js-preloader").fadeOut();
    wow = new WOW({
      mobile: false
    });
    wow.init();
};